import { render, staticRenderFns } from "./ParticipacaoValorTotalDepreciacoesAbsoluto.vue?vue&type=template&id=2be8d494&scoped=true&"
import script from "./ParticipacaoValorTotalDepreciacoesAbsoluto.vue?vue&type=script&lang=js&"
export * from "./ParticipacaoValorTotalDepreciacoesAbsoluto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be8d494",
  null
  
)

export default component.exports